/**
 * Loại tạo dữ liệu
 * NVTUAN1 21.08.2024
 */
export default {
  /// <summary>
  /// Tạo mới dữ liệu
  /// </summary>
  CreateData: 1,

  /// <summary>
  /// Tạo mới dữ liệu từ năm trước
  /// </summary>
  CreateDataPrevYear: 2,

  /// <summary>
  /// Chuyển chế độ kế toán
  /// </summary>
  ConversionOfAccountingSystem: 3,

  /// <summary>
  /// Dữ liệu phục hồi
  /// </summary>
  RestoreData : 4,

  /// <summary>
  /// DL chuyển đổi từ Desktop
  /// </summary>
  ConvertDesktop : 5,
};
